import { render, staticRenderFns } from "./DetailInbox.vue?vue&type=template&id=47b444f7&"
import script from "./DetailInbox.vue?vue&type=script&lang=js&"
export * from "./DetailInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports